import React, { useContext } from "react";
import classnames from "classnames";
import { compose } from "redux";
import { useSelector } from "react-redux";
import logo from "../../../assets/logo_white.svg";
import logo_t from "../../../assets/logo_t.svg";
import isMobile from "../../../utilities/isMobile";
import { withBreakpoint, LayoutContext } from "../../common/wrappers";
import { Text, Logo } from "../../common";
import Tooltip from "@material-ui/core/Tooltip";
import {
  DashboardIcon,
  PaymentsIcon,
  RewardsIcon,
  ReferralsIcon,
  StatementsIcon,
  SettingsIcon,
  TransactionsIcon,
  SupportIcon,
} from "../../common/Svg";
import { parseInfo } from "./navHelper";

const items = {
  dashboard: {
    Icon: DashboardIcon,
  },
  payments: {
    Icon: PaymentsIcon,
  },
  activity: {
    Icon: TransactionsIcon,
  },
  rewards: {
    Icon: RewardsIcon,
  },
  referrals: {
    Icon: ReferralsIcon,
  },
  statements: {
    Icon: StatementsIcon,
  },
  settings: {
    Icon: SettingsIcon,
  },
  // support: {
  //   Icon: SupportIcon,
  //   title: "Contact support",
  // },
};

const NavbarDesktop = ({
  breakpointContext: { isBelow },
  showMenu,
  onClick,
}) => {
  const { forceCollapse } = useContext(LayoutContext);
  const showingWideMenu = !forceCollapse && (!isBelow("xl") || showMenu);

  return (
    <div
      className="flex justify-center w-full h-screen"
      style={{
        background: "linear-gradient(#030E0E 0%, rgb(0, 0, 0) 100%)",
      }}
    >
      <div className="flex flex-col w-full">
        <button type="button" style={{ outline: 0 }}>
          {!showingWideMenu ? (
            <div className="py-4 pl-3 bg-black-secondary">
              <img
                src={logo_t}
                style={{ width: "auto", height: 36 }}
                className="w-1/2"
                alt="logo"
              />
            </div>
          ) : (
            <Logo
              white
              className="w-8/12 mx-auto"
              style={{ justifyContent: "center" }}
            />
          )}
        </button>
        <div className="">
          {Object.entries(items).map(([key, { Icon, title }], index) => {
            if (key === "referrals") return null;
            const { route, color } = parseInfo(key, "", "white");
            const isSupport = key === "support";
            const isDashboard = key === "dashboard";
            return (
              <div
                key={key}
                role="presentation"
                className={classnames(
                  "flex p-3 cursor-pointer w-full mx-auto",
                  {
                    "border-t": index && !isSupport,
                    absolute: isSupport,
                    "pl-12": showMenu && !isSupport,
                  }
                )}
                style={{
                  borderColor: "#ddf0ed1f",
                  bottom: isSupport ? "10px" : null,
                }}
              >
                <div
                  className={classnames(
                    "flex items-center",
                    {
                      "px-2 rounded bg-support hover:bg-primary text-sm w-full":
                        isSupport && showingWideMenu,
                    },
                    { "py-6": isSupport }
                  )}
                  style={{ height: "28px" }}
                >
                  <Tooltip
                    title={
                      !isDashboard
                        ? "Please follow the instructions on the page to continue."
                        : ""
                    }
                  >
                    <div className="mx-auto">
                      <Icon
                        color={color}
                        style={{ width: "24px" }}
                        className="float-left"
                      />
                      <Text
                        // size="lg"
                        weight="medium"
                        color={color}
                        className={classnames(
                          "pl-2 capitalize flex",
                          { hidden: !showingWideMenu },
                          { "text-lg": !isSupport },
                          { "text-sm": isSupport }
                        )}
                      >
                        {title || key}
                      </Text>
                    </div>
                  </Tooltip>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default compose(withBreakpoint)(NavbarDesktop);
